<template>
    <div style="background:#e5e5e5;padding:20px;">
        <FullPageLoader :isLoading="loading"/>

        <h3><strong>Test module</strong></h3>
        <p>Voer de geautomatiseerde taken van PlanitEasy uit.</p>
        <b-button type="is-primary" @click="fetchShifts">Verversen</b-button>
        <hr>

        <div class="row">
            <div class="column small-6">
                <h4>Payment Shift</h4>

                <p>Simuleer een datum</p>
                <b-datepicker v-model="paymentDate" inline :nearby-selectable-month-days="true"></b-datepicker>

                <br>

                <div v-if="!paymentShiftPossible && !loading">
                    <p>Geen betalingen gevonden om uit te voeren op datum<br> {{ moment(paymentDate).format('DD-MM-YYYY') }}.</p>
                </div>
                <div v-else-if="!loading">
                    <p>Eerst volgende betaling gevonden om uit te voeren: <router-link :to="{ name: 'InvoicesRecord', params: {type: 'ingepland', id: paymentTask ? paymentTask.invoice : ''} }">Factuur {{ paymentTask ? paymentTask.invoice : '(Onbekend)' }}</router-link> van &euro;&nbsp;{{ paymentTask.total - paymentTask.paid }}.</p>

                    <div v-if="paymentTask.type == 'manual'">
                        <p>Dit is een handmatig betaling. Deze betaling dient handmatig ingevuld te worden bij de factuur.</p>
                    </div>
                    <div v-else>
                        <b-button type="is-success" @click="runPaymentShift(true)" v-show="!paymentTask.status == 'incasso_planned'">Betaling succes</b-button>
                        <b-button type="is-danger" @click="runPaymentShift(false)" v-show="!paymentTask.status == 'incasso_planned'">Betaling mislukt</b-button>

                        <p v-show="paymentTask.status == 'incasso_planned'">Betaling controleren bij Pay.nl</p>
                        <b-button type="is-primary" @click="runPaymentShift('paynl')">Pay.nl</b-button>
                    </div>
                </div>
            </div>
            <div class="column small-6">
                <h4>Communicatie Shift</h4>

                <div v-if="!communicationShiftPossible">
                    <p>Geen communicatie-taken om uit te voeren.</p>
                </div>
                <div v-else>
                    <p>Communicatie taken om uit te voeren:</p>

                    <b-table
                        :data="communicationTasks"
                        :striped="true"
                        :mobile-cards="true"

                        :per-page="1000"
                    >
                        <template>
                            <b-table-column v-slot="props" label="Taak" width="300">
                                {{ taskToText(props.row.task) }}
                            </b-table-column>
                            <b-table-column v-slot="props" label="Factuur" width="300">
                                <b-button v-if="props.row.invoice" tag="router-link" type="is-dark" :to="{ name: 'InvoicesRecord', params: {type: 'ingepland', id: props.row.invoice} }">{{ props.row.invoice }}</b-button>
                                <span v-else>-</span>
                            </b-table-column>
                            <b-table-column v-slot="props" label="Organisatie">
                                <b-button type="is-primary" tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }">
                                    {{ props.row.organisation || '-' }}
                                </b-button>
                            </b-table-column>
                            <b-table-column v-slot="props" label="Overslaan">
                                {{ props.row.skip > 0 ? props.row.skip +'x' : 'Nee' }}
                            </b-table-column>
                        </template>
                    </b-table>

                    <br>

                    <!-- <b-field>
                        <b-checkbox v-model="removeAfterRun">Taken uit lijst halen na uitvoeren</b-checkbox>
                    </b-field> -->
                    <b-button type="is-primary" @click="runCommunicationShift">Uitvoeren</b-button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TestModule',

    data() {
        return {
            loading: false,
            paymentDate: new Date(),

            paymentShiftPossible: false,
            communicationShiftPossible: false,

            paymentTask: {},
            communicationTasks: [],

            // removeAfterRun: true
        }
    },

    computed: {
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        }
    },

    created() {
        this.fetchShifts()
    },

    methods: {
        fetchShifts(){
            this.loading = true

            axios({
                method: 'get',
                url: `/api/shifts?date=${moment(this.paymentDate).format('YYYY-MM-DD')}`,
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.paymentTask = response.data.payment
                this.communicationTasks = response.data.communication

                this.paymentShiftPossible = !_.isNull(response.data.payment)
                this.communicationShiftPossible = !!response.data.communication.length
            }).catch((error) => {
                console.error('[❌] Error while fetching shifts', error)
            }).then(() => {
                this.loading = false
            })
        },


        runPaymentShift(type){
            this.loading = true

            axios({
                method: 'get',
                url: `/api/shifts/payment?date=${moment(this.paymentDate).format('YYYY-MM-DD')}&success=${type}`,
                timeout: '60000', //1 min
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                // Nothing to do with it.
            }).catch((error) => {
                console.error('[❌] Error while fetching shifts', error)
            }).then(() => {
                this.loading = false

                setTimeout(() => {
                    this.fetchShifts()
                }, 100)
            })
        },

        runCommunicationShift(){
            this.loading = true

            axios({
                method: 'get',
                url: `/api/shifts/communication`,
                timeout: '60000', //1 min
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                // Nothing to do with it.
            }).catch((error) => {
                console.error('[❌] Error while fetching shifts', error)
            }).then(() => {
                this.loading = false

                setTimeout(() => {
                    this.fetchShifts()
                }, 100)
            })
        },


        taskToText(task){
            switch(task){
                case 'create_invoice_record':
                    return 'Nieuw systeem invoice record'
                break;
                case 'create_invoice_paid':
                    return 'Genereer betaalbevestiging PDF'
                break;
                case 'create_invoice':
                    return 'Genereer factuur PDF'
                break;
                case 'send_invoice_mail':
                    return 'Verstuur factuur of betaalbevestiging mail'
                break;
                default:
                    return task
                break;
            }
        }
    },

    watch: {
        paymentDate(newVal){
            if(newVal) this.fetchShifts()
        }
    }
}
</script>